"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.keys = exports.clear = exports.remove = exports.set = exports.get = void 0;

var _storage = require("./storage");

var get = function get(key) {
  try {
    return (0, _storage.get)((0, _storage.check)('localStorage'), key);
  } catch (err) {
    console.error(err.message);
  }

  return null;
};

exports.get = get;

var set = function set(key) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var expiryInMinutes = arguments.length > 2 ? arguments[2] : undefined;

  try {
    expiryInMinutes = (0, _storage.isNotEmpty)(expiryInMinutes) ? expiryInMinutes : null;
    return (0, _storage.set)((0, _storage.check)('localStorage'), key, value, expiryInMinutes);
  } catch (err) {
    console.error(err.message);
  }

  return false;
};

exports.set = set;

var remove = function remove(key) {
  try {
    return (0, _storage.remove)((0, _storage.check)('localStorage'), key);
  } catch (err) {
    console.error(err.message);
  }

  return false;
};

exports.remove = remove;

var clear = function clear() {
  try {
    return (0, _storage.clear)((0, _storage.check)('localStorage'));
  } catch (err) {
    console.error(err.message);
  }

  return false;
};

exports.clear = clear;

var keys = function keys() {
  try {
    return (0, _storage.keys)((0, _storage.check)('localStorage'));
  } catch (err) {
    console.error(err.message);
  }

  return false;
};

exports.keys = keys;

var _default = function _default() {
  return {
    get: get,
    set: set,
    remove: remove,
    clear: clear,
    keys: keys
  };
};

exports.default = _default;